import styled from 'styled-components';
import { m, mb, ml, mr, pb, pt } from '@upgrade/react-components/Spacing/core';
import { Hero } from '../common/styles';
import Highlights from '../common/Highlights';
import Image from '../common/Image';

export const StyledGridContainer = styled.div`
  display: grid;
  @media (min-width: ${props => props.theme.mediaSm}) {
    grid-template-columns: 1fr 6fr 5fr;
  }
`;

export const StyledHero = styled(Hero)`
  ${pt('none')};
  ${pb('xl')};
  background-image: url(${({ 'data-image': img, displayImageMobile }) => (displayImageMobile ? img : 'none')});
  background-position: 70% 30%;
  background-size: 70rem;
  @media (min-width: ${props => props.theme.mediaSm}) {
    ${pt('2xl')};
    background-size: cover;
    background-position: 50%;
  }
`;

export const StyledHeroSection = styled.div`
  grid-column-start: 1;
  ${pt('none')};
  @media (min-width: ${props => props.theme.mediaSm}) {
    grid-column-start: 2;
  }
`;

export const StyledHeader = styled.div`
  h1 {
    font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xl.fontSize};
    font-weight: 800;
    ${mb('md')};
    line-height: 3rem;
    letter-spacing: -0.5px;
  }
  h2 {
    font-size: ${({ theme }) => theme.typography.sizes.headings.mobile.md.fontSize};
    ${mb('none')};
  }
  @media (min-width: ${({ theme: { mediaSm } }) => mediaSm}) {
    h1 {
      font-size: ${({ theme }) => theme.typography.sizes.headings.mobile.number_xl.fontSize};
      font-weight: 800;
      line-height: 4rem;
      margin-bottom: 1.875rem;
    }
    h2 {
      ${mb('md')};
      font-size: ${({ theme }) => theme.typography.sizes.text.mobile.xl.fontSize};
    }
  }
`;

export const StyledCtaContainer = styled.div`
  grid-row-start: 3;
  ${mb('xl')};
  @media (min-width: ${props => props.theme.mediaMd}) {
    grid-row-start: 2;
    grid-column-start: 2;
    width: 66.66%;
    justify-self: left;
  }
`;

export const StyledInsuranceNotice = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.625rem;
`;

export const StyledInsuranceIcon = styled.div`
  ${mr('sm')};
  margin-bottom: 1px;
`;

export const StyledInsuranceNoticeText = styled.div`
  display: flex;
  justify-content: ${props => (props.justify ? props.justify : 'center')};
  color: ${({ theme, 'data-color': dataColor }) => theme.palette[dataColor] || theme.palette.contentWeak};
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xs.fontSize};
`;

export const StyledRewardsCheckingImage = styled.div`
  grid-row-start: 2;
  ${pb('md')};

  @media (min-width: ${props => props.theme.mediaSm}) {
    grid-row-start: 1;
    grid-row-end: 4;
    grid-column-start: 3;
    grid-column-end: 3;
    align-self: center;
    padding: 0;
  }

  img {
    max-width: 100%;
  }
`;

export const StyledSeparator = styled.div`
  border-bottom: 1px solid ${props => props.theme.palette.actionablePrimary};
  ${ml('md')};
  ${mr('md')};
  @media (min-width: ${props => props.theme.mediaSm}) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
`;

export const HeroItemsWrapper = styled.div`
  margin-bottom: 0rem;
  @media (min-width: ${props => props.theme.mediaSm}) {
    ${mb('md')};
  }
`;

export const StyledImgDesktop = styled(Image)`
  display: none;
  max-width: 100%;
  height: auto;
  @media (min-width: ${props => props.theme.mediaSm}) {
    display: block;
  }
`;

export const StyledHighlights = styled(Highlights)`
  @media (min-width: ${props => props.theme.mediaSm}) {
    ${mb('md')};
  }
  & div {
    width: calc(100% - 4rem);
    p {
      font-weight: 500;
      font-size: ${({ theme }) => theme.typography.sizes.text.desktop.sm.fontSize};
      @media (min-width: ${props => props.theme.mediaSm}) {
        font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
      }
    }
    @media (min-width: ${props => props.theme.mediaSm}) {
      ${m('none')};
    }
  }
  & li > span[class*=' icon-'] {
    height: 20px;
    width: 20px;
    border-radius: ${({ solid }) => (solid ? '50%' : '0')};
    background-color: ${({ solid, theme }) => (solid ? theme.palette.actionablePrimary : 'inherit')};
    color: ${({ solid, theme }) => (solid ? theme.palette.contentReverse : theme.palette.actionablePrimary)};
    ${ml('none')};
    @media (min-width: ${props => props.theme.mediaSm}) {
      margin-left: ${({ solid }) => (solid ? '1rem' : '0')};
    }
    &::before {
      left: 5px;
      top: -4px;
      font-size: ${({ theme }) => theme.typography.sizes.text.desktop.xxs.fontSize};
      position: relative;
    }
  }
`;
